const GetHash = (search) => {
  const hash = new URLSearchParams(search).get("hash");
  return hash;
};

export default GetHash;
